// Rutas del módulo videos: objetos de ruta hijos del Layout (ver src/Routes.js).
const AdministracionVideos = () => import('@/pages/Administracion/Videos/Videos.vue');

export default [
    {
        path: '/administracion/videos',
        name: 'AdministracionVideos',
        component: AdministracionVideos,
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {name: 'Inicio', href: 'Inicio'},
                {name: 'Administración', href: 'Administracion'},
                {name: 'Videos y slider'},
            ],
        },
    },
];
